exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-haz-parte-de-nuestra-familia-jsx": () => import("./../../../src/pages/haz-parte-de-nuestra-familia.jsx" /* webpackChunkName: "component---src-pages-haz-parte-de-nuestra-familia-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

